import { JSONValue } from '@twilio/conversations';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

import { client } from '../client';
import { IGMConversation } from './types/IGMConversation';

export interface CreateConversationPayload {
  friendly_name?: string;
  participants: Array<{
    identity: string;
  }>;
  attributes?: JSONValue;
  conversation_type: string;
  case_id: number;
}

export const createConversation = async (
  payload: CreateConversationPayload,
  userRole?: string,
): Promise<IGMConversation> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.post<IGMConversation>(`${prefix}/conversations`, payload);
    return data;
  }
  try {
    const { data } = await client.post<IGMConversation>('/conversations', payload);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.post<IGMConversation>(`${collectorPrefix}/conversations`, payload);
      return data;
    }
    throw error;
  }
};
